import { useEffect, useState } from 'react'
import { Copy, XCircle } from 'lucide-react'
import api from '../api/client'
import Pagination from '../components/Pagination'
import SearchableSelect from '../components/SearchableSelect'
import { confirmModal, successModal } from '../components/ui'

export default function Pedidos() {
  const [produtos, setProdutos] = useState([])
  const [clientes, setClientes] = useState([])
  const [pedidos, setPedidos] = useState([])
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(20)
  const [meta, setMeta] = useState({ total: 0, pages: 1 })
  const [cart, setCart] = useState({})
  const [clienteId, setClienteId] = useState('')
  const [nomeManual, setNomeManual] = useState('')
  const [whats, setWhats] = useState('')
  const [msg, setMsg] = useState('')

  function carregar(p = 1, sz = size) {
    api.get(`/pedidos?page=${p}&limit=${sz}`).then((r) => {
      setPedidos(r.data.data || [])
      setMeta({ total: r.data.total || 0, pages: r.data.pages || 1 })
      setPage(p)
    }).catch(() => {})
  }
  useEffect(() => {
    api.get('/ofertas/publico?tipo=produto').then((r) => setProdutos(r.data)).catch(() => {})
    api.get('/clientes?limit=100').then((r) => setClientes(r.data.data)).catch(() => {})
    carregar(1)
  }, [])

  async function cancelar(id) {
    if (!(await confirmModal('Deseja realmente cancelar este pedido?', { title: 'Cancelar pedido', danger: true, okLabel: 'Cancelar pedido', cancelLabel: 'Voltar' }))) return
    try { await api.post(`/pedidos/${id}/cancelar`); carregar(page); successModal('Pedido cancelado.') } catch { /* noop */ }
  }

  function add(id) { setCart((c) => ({ ...c, [id]: (c[id] || 0) + 1 })) }
  function sub(id) { setCart((c) => ({ ...c, [id]: Math.max(0, (c[id] || 0) - 1) })) }

  const itens = produtos.filter((p) => cart[p.id] > 0)
  const total = itens.reduce((s, p) => s + p.preco * cart[p.id], 0)
  const pvTotal = itens.reduce((s, p) => s + (p.pv || 0) * cart[p.id], 0)

  async function enviar() {
    setMsg('')
    const cli = clientes.find((c) => c.id === Number(clienteId))
    const lic = JSON.parse(localStorage.getItem('licenciado') || 'null')
    const body = {
      licenciado_id: lic?.id || null,
      cliente_id: cli?.id || null,
      nome_cliente: cli?.nome || nomeManual,
      whatsapp_cliente: cli?.whatsapp || whats,
      origem: 'carrinho_sugerido',
      itens: itens.map((p) => ({ oferta_id: p.id, qtd: cart[p.id] })),
    }
    const { data } = await api.post('/pedidos', body)
    const { data: env } = await api.post(`/pedidos/${data.id}/enviar?canal=whatsapp`)
    setMsg(`Pedido ${data.codigo} enviado! Link de pagamento: ${env.link || '(gerado)'}`)
    setCart({})
    carregar(1)
    successModal(`Pedido ${data.codigo} criado e enviado ao cliente.`, { title: 'Pedido enviado!' })
  }

  const STc = { carrinho: 'bg-gray-100', aguardando_pagamento: 'bg-tc-yellow/40', pago: 'bg-green-100', cancelado: 'bg-red-100' }

  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2">
        <h1 className="text-2xl font-heading font-bold text-gray-900 mb-4">Fazer Pedidos — Carrinho Sugerido</h1>
        <div className="grid sm:grid-cols-2 gap-4">
          {produtos.map((p) => (
            <div key={p.id} className="bg-white rounded-xl p-4 shadow-sm flex gap-3">
              {p.imagem_url && <img src={p.imagem_url} alt="" className="w-16 h-16 rounded object-cover" />}
              <div className="flex-1">
                <p className="font-medium text-sm">{p.nome}</p>
                <p className="text-tc-orange text-sm font-semibold">R$ {Number(p.preco).toFixed(2)} · {p.pv} PV</p>
                <div className="flex items-center gap-2 mt-1">
                  <button onClick={() => sub(p.id)} className="w-6 h-6 rounded bg-gray-100">-</button>
                  <span className="text-sm">{cart[p.id] || 0}</span>
                  <button onClick={() => add(p.id)} className="w-6 h-6 rounded bg-tc-orange text-white">+</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <h2 className="text-lg font-heading font-bold text-gray-900 mt-8 mb-3">Pedidos recentes</h2>
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-500 text-left text-xs uppercase tracking-wider">
              <tr><th className="px-3 py-2">Código</th><th className="px-3 py-2">Cliente</th>
                <th className="px-3 py-2">Total</th><th className="px-3 py-2">PV</th><th className="px-3 py-2">Status</th>
                <th className="px-3 py-2 text-right">Ações</th></tr>
            </thead>
            <tbody>
              {pedidos.map((p) => (
                <tr key={p.id} className="border-t border-gray-100 hover:bg-primary-50/30">
                  <td className="px-3 py-2 font-mono text-xs">{p.codigo}</td>
                  <td className="px-3 py-2">{p.nome_cliente || '—'}</td>
                  <td className="px-3 py-2">R$ {Number(p.total).toFixed(2)}</td>
                  <td className="px-3 py-2">{p.pv_total}</td>
                  <td className="px-3 py-2"><span className={`px-2 py-0.5 rounded text-xs ${STc[p.status] || 'bg-gray-100'}`}>{p.status}</span></td>
                  <td className="px-3 py-2">
                    <div className="flex items-center justify-end gap-1">
                      {p.link_pagamento && (
                        <button onClick={() => navigator.clipboard?.writeText(p.link_pagamento)} title="Copiar link de pagamento"
                          className="p-1.5 rounded-lg text-tc-smoke hover:text-tc-orange hover:bg-tc-orange/10"><Copy size={15} /></button>
                      )}
                      {p.status !== 'pago' && p.status !== 'cancelado' && (
                        <button onClick={() => cancelar(p.id)} title="Cancelar pedido"
                          className="p-1.5 rounded-lg text-tc-smoke hover:text-red-600 hover:bg-red-50"><XCircle size={15} /></button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {pedidos.length === 0 && <tr><td colSpan="6" className="px-3 py-6 text-center text-tc-smoke">Nenhum pedido.</td></tr>}
            </tbody>
          </table>
        </div>
        <Pagination page={page} pages={meta.pages} total={meta.total} pageSize={size} onPage={carregar} onPageSize={(n) => { setSize(n); carregar(1, n) }} />
      </div>

      <div className="bg-white rounded-xl p-5 shadow-sm h-fit">
        <p className="font-heading text-lg mb-3">Resumo do Carrinho</p>
        {itens.map((p) => (
          <div key={p.id} className="flex justify-between text-sm py-1">
            <span>{cart[p.id]}× {p.nome}</span><span>R$ {(p.preco * cart[p.id]).toFixed(2)}</span>
          </div>
        ))}
        <div className="flex justify-between font-semibold border-t mt-2 pt-2">
          <span>Total</span><span>R$ {total.toFixed(2)}</span>
        </div>
        <p className="text-xs text-tc-orange">{pvTotal} PV</p>

        <div className="mt-4 space-y-2">
          <SearchableSelect value={clienteId} onChange={setClienteId} placeholder="Cliente cadastrado..."
            options={clientes.map((c) => ({ value: c.id, label: c.nome }))} />
          {!clienteId && (
            <>
              <input placeholder="Ou nome do cliente" value={nomeManual} onChange={(e) => setNomeManual(e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm" />
              <input placeholder="WhatsApp" value={whats} onChange={(e) => setWhats(e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm" />
            </>
          )}
          <button onClick={enviar} disabled={!itens.length}
            className="w-full rounded-lg bg-tc-orange text-white py-2.5 font-semibold disabled:opacity-50">
            Enviar para aprovação e pagamento
          </button>
        </div>
        {msg && <p className="text-xs bg-tc-yellow/30 rounded p-2 mt-3 break-all">{msg}</p>}
      </div>
    </div>
  )
}
